// LO QUE DICE LA NAVBAR, y vive en `data/` y no dentro del componente por dos motivos.
//
// El primero es que esto son PALABRAS, no interfaz: son las que decide el glosario
// (`docs/estado/glosario.md`) y las que hay que cambiar cuando cambia el vocabulario de la
// plataforma. Buscarlas dentro de cuatrocientas lineas de menu, submenu movil y avatar era
// justo lo que hacia que se quedaran viejas.
//
// El segundo es de tamaño: `Navbar.jsx` estaba en 404 lineas con el limite en 400
// (`tools/check_tamano.py`), y de esas, cincuenta y seis eran esta lista.

import { COURSES, COMPETENCIA_ORDER, COMING_SOON } from "@/data/courses";

const EMPRENDIMIENTO = COMING_SOON.find((c) => c.pantalla);

export const NAV_ITEMS = [
  {
    key: "agora",
    // SE LLAMA «MUNDO 3D» DESDE EL 18 DE OCTUBRE DE 2026, y lo pidió Gabri el día que esa
    // página dejó de abrirse con un titular y pasó a abrirse con la puerta del mundo y las
    // tres del Ágora, todas a la vista. El menú decía «Ágora», que es el nombre de la plaza
    // —y de un sitio DENTRO del mundo—, no el de lo que se encuentra al entrar.
    //
    // LA CLAVE Y LA RUTA NO CAMBIAN: `/mundo` sigue siendo `/mundo`. Un nombre de cara al
    // alumno y una dirección guardada son dos cosas distintas, y hay enlaces repartidos
    // -`check_rutas.py` vigila una docena- que apuntan ahí.
    label: "Mundo 3D",
    to: "/mundo",
    // SIN DESPLEGABLE DESDE EL 29 DE OCTUBRE DE 2026 (Gabri: *«no me parece útil la navbar del
    // mundo. Quítala»*). Repetía lo que la página enseña nada más abrirla —el mundo y las tres
    // puertas, en botones— y un menú que dice lo mismo que la pantalla a la que lleva es un paso
    // de más. «Mundo 3D» lleva a `/mundo`, como «Precios» a su página. Las anclas de las puertas
    // siguen valiendo para quien las tenga guardadas: abren su hoja.
  },
  {
    key: "origen",
    label: "Origen",
    to: "/origen",
    bubbles: [
      { title: "Manifiesto", desc: "Aprender es transformarse.", to: "/origen#manifiesto" },
      { title: "Valores", desc: "Lo que sostiene la Academia.", to: "/origen#valores" },
      { title: "El profesor", desc: "Ángel Gabriel, fundador.", to: "/origen#profesor" },
      { title: "Metodología", desc: "Los 6 sistemas Alpha.", to: "/origen/metodologia" },
    ],
  },
  {
    key: "cursos",
    // VUELVE A DECIR «CURSOS» EL 7 DE OCTUBRE DE 2026, y no es deshacer el cambio de
    // septiembre: es que la pagina del otro lado ya no es la que era. Entonces `/cursos`
    // enseñaba las cinco competencias y nada mas, asi que el rotulo «Cursos» mentia y se
    // cambio. El 15 de septiembre la pagina se dio la vuelta -lo primero bajo el buscador
    // son los cursos del CMS, y las cinco quedan debajo con un «O por competencia»- y el
    // rotulo se quedo atras. Gabri, 7 de octubre: *«los alumnos se pierden»*.
    //
    // LA REGLA, QUE ES LA MISMA DE LAS DOS VECES: **el rotulo dice lo que hay al otro
    // lado.** Y el desplegable copia el orden de la pagina por lo mismo. La ruta no cambia:
    // renombrarla rompe enlaces ya publicados. Jerarquia en `docs/estado/glosario.md`.
    label: "Cursos",
    to: "/cursos",
    // «TODOS LOS CURSOS» BAJA A UN ENLACE (18 oct 2026). Eran seis burbujas -la del catalogo y
    // las cinco competencias- y no cabia una sexta competencia: Gabri, *«no cabe otro bocadillo
    // más»*. Las burbujas quedan para las competencias, dos filas de tres, y el catalogo entero
    // va debajo en una linea. No se pierde nada: «Cursos» en la barra ya lleva ahi.
    pie: { title: "Todos los cursos", desc: "Los publicados, ordenados por año", to: "/cursos" },
    // LO QUE SE VENDE ES LA COMPETENCIA, NO LA ASIGNATURA. La página de Cursos lo dice
    // en su titular —«No estudias asignaturas»— y el desplegable decía justo lo contrario:
    // Filosofía, Literatura, Psicología… La disciplina baja al subtítulo, que es donde
    // sigue haciendo falta —quien busca «Latín» tiene que encontrarlo— sin ser el reclamo.
    //
    // Y en el ORDEN DE PRESENTACIÓN, el mismo que la página de Cursos: dos listas de las
    // mismas cinco rutas en distinto orden es la clase de detalle que hace dudar de si son
    // lo mismo.
    bubbles: [
      ...COMPETENCIA_ORDER
        .map((slug) => COURSES.find((c) => c.slug === slug))
        .filter(Boolean)
        .map((c) => ({
          title: c.nombreCompetencia,
        // Las materias publicadas, no la disciplina suelta: el desplegable es donde alguien
        // comprueba si damos «Latín» o «Historia de la Filosofía», y con una sola palabra
        // no lo podía comprobar.
        //
        // Y AQUI NO VAN LOS CURSOS, que se probaron el 17 de octubre de 2026 y duraron una
        // tarde: *«no pongas ningun curso debajo de la competencia de la navbar. se ve muy
        // grueso»*. Una materia es una palabra; un titulo publicado son seis, y a veces dos
        // lineas. El porque entero, en `Navbar.jsx`.
          desc: (c.asignaturas || [c.discipline]).join(" · "),
        // Y DE QUÉ COMPETENCIA ES CADA UNA: sin esto no hay ni cursos que pedir ni color que
        // pintar, y la burbuja saldría gris y con las materias de siempre, callada.
          competencia: c.slug,
          emoji: c.emoji,
          to: `/cursos/${c.slug}`,
        })),
      // LA SEXTA, POR LLEGAR: Emprendimiento. Bloqueada y sin color de competencia, y al pulsarla
      // suma uno en el recuento de pantallas (`pantalla`) antes de llevar a la tarjeta de Cursos.
      ...(EMPRENDIMIENTO ? [{
        title: EMPRENDIMIENTO.name,
        desc: ["Próximamente", ...(EMPRENDIMIENTO.asignaturas || [])].join(" · "),
        emoji: EMPRENDIMIENTO.emoji,
        to: "/cursos#proximamente",
        pantalla: EMPRENDIMIENTO.pantalla,
        proximamente: true,
      }] : []),
    ],
  },
  // ── LAS HERRAMIENTAS, EN UN SOLO SITIO ────────────────────────────────────────────────
  //
  // ERAN SEIS ENLACES SUELTOS —Lab, Tests, Boletín, Recuerdos, Lecturas, Precios— y con los
  // tres de arriba hacían NUEVE cosas en la barra. Nueve opciones en una fila no son un menú:
  // son una lista que hay que leer entera antes de decidir, y se lee cada vez que se entra.
  //
  // Y NO SE HA QUITADO NADA, que era la otra salida y la mala: las cinco siguen ahí, con su
  // ruta intacta, una línea más abajo. Lo que cambia es que ahora hay que preguntar por ellas
  // en vez de tropezárselas, y eso es exactamente lo que se quiere de una herramienta: quien
  // la busca la encuentra; quien no sabe todavía qué es la Academia no tiene que apartarla.
  //
  // PRECIOS SE QUEDA FUERA DEL GRUPO, y es la única excepción. No es una herramienta: es la
  // pregunta que se hace todo el que está decidiendo, y esconderla detrás de un desplegable es
  // el truco que hace desconfiar. Cuatro pilares y el precio a la vista.
  //
  // EL ORDEN DE DENTRO es el del alumno y no el alfabético: primero lo que se usa estudiando
  // —el Laboratorio y los tests—, después lo que se lee, y al final lo que llega solo.
  {
    key: "herramientas",
    label: "Herramientas",
    // NO TIENE PÁGINA PROPIA, y es a propósito: una página «Herramientas» que sólo fuera cinco
    // enlaces es un rellano —se llega, se vuelve a elegir y se sigue—. El desplegable ya enseña
    // las cinco con lo que hace cada una, que es lo que una página así podría añadir.
    sinPagina: true,
    to: null,
    bubbles: [
      // SE LLAMABA «LABORATORIO», y antes «Alpha Lab». Ninguno de los dos dice lo que hay
      // dentro: un laboratorio puede ser cualquier cosa. Decision de Gabri del 27 de
      // septiembre de 2026 —«debe ser mas claro»—: el sitio se llama **Skills**, que es como
      // lo dicen los alumnos, y el subtitulo dice de que van.
      { title: "Skills", desc: "Técnicas de estudio.", to: "/lab" },
      { title: "Tests", desc: "Por dónde empezar y cómo aprendes.", to: "/tests" },
      { title: "Lecturas", desc: "La biblioteca de la Academia.", to: "/lecturas" },
      { title: "Recuerdos", desc: "Lo que has ido haciendo, guardado.", to: "/recuerdos" },
      { title: "Boletín", desc: "Lo que publicamos cada semana.", to: "/newsletter" },
    ],
  },
  { key: "precios", label: "Precios", to: "/precios" },
];
